import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Button } from 'react-bootstrap';

import './tool-panel.css';
import { openModal, 
  executeChallenge, 
  isHelpModalOpenSelector, 
  isHintModalOpenSelector, 
} from '../redux';

import HelpModal from './HelpModal';
import HintModal from './HintModal';

const mapStateToProps = (state) => ({
  isHelpModalOpen: isHelpModalOpenSelector(state),
  isHintModalOpen: isHintModalOpenSelector(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      executeChallenge,
      openChatbotModal: () => openModal('help', 'chatbot'),
      openPlaygroundModal: () => openModal('help', 'playground'),
      openHintModal: () => openModal('hint'),
      openResetModal: () => openModal('reset'),
    },
    dispatch
  );

const propTypes = {
  executeChallenge: PropTypes.func.isRequired,
  guideUrl: PropTypes.string,
  openChatbotModal: PropTypes.func.isRequired,
  openPlaygroundModal: PropTypes.func.isRequired,
  openHintModal: PropTypes.func.isRequired,
  openResetModal: PropTypes.func.isRequired,
  isHelpModalOpen: PropTypes.bool.isRequired,
  isHintModalOpen: PropTypes.bool.isRequired,
};

function ToolPanel({
  executeChallenge,
  openChatbotModal,
  openPlaygroundModal,
  openHintModal,
  openResetModal,
  guideUrl,
  isHelpModalOpen
}) {
  return (
    <Fragment>
      <div className='tool-panel-group'>
        <Button block={true} bsStyle='primary' onClick={executeChallenge}>
          Run Codes
        </Button>
        <Button
          block={true}
          bsStyle='primary'
          className='btn-primary-invert'
          onClick={openResetModal}
          >
          Reset Codes
        </Button>
        <Button
          block={true}
          bsStyle='primary'
          className='btn-primary-invert'
          onClick={openHintModal}
          >
          Get Hint
        </Button>
        <HintModal guideUrl={guideUrl} />
        <Button
          block={true}
          bsStyle='primary'
          className='btn-primary-invert'
          onClick={openChatbotModal}
          >
          Get Help
        </Button>
        <HelpModal/>
        <Button
          block={true}
          bsStyle='primary'
          className='btn-primary-invert'
          onClick={openPlaygroundModal}
        >
          Playground
        </Button>
        <HelpModal />
        {/* <Button
          block={true}
          bsStyle='primary'
          className='btn-primary-invert'
          onClick={openPlaygroundModal}
          >
          Playground
        </Button>
        <PlaygroundModal/> */}
      </div>
    </Fragment>
  );
}

ToolPanel.displayName = 'ToolPanel';
ToolPanel.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(ToolPanel);



// WEBPACK FOOTER //
// ./src/templates/Challenges/components/Tool-Panel.js